import { Outlet } from "react-router-dom";
import { Header } from "../components/Header/Header";
import { Footer } from "../components/Footer/Footer";
import { MainContent } from "../components/MainContent/MainContent";

export const MainLayout = () => {

  return (
    <>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />
      <MainContent>
        <Outlet />
      </MainContent>
      <Footer/>
    </>
  );
};
